import { useMemo } from 'react';

export const useLabelLocationRight = () => {
  const labelLocationRight = useMemo(
    () => ({
      location: 'right',
      showColon: false
    }),
    []
  );

  return labelLocationRight;
};
